var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpFeatureIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v110H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.133 41.736a3.263 3.263 0 0 1-2.375-1.54l-7.553-12.521 1.241-.5-1.193-2.966a1.264 1.264 0 0 0-1.644-.7l-6.622 2.663a1.265 1.265 0 0 0-.7 1.644l1.192 2.966 1.241-.5 3.22 14.265a3.263 3.263 0 0 1-.648 2.756 9.87 9.87 0 0 0-1.458 9.859L74.21 85.444a5.428 5.428 0 0 0 7.06 3.01l13.107-5.27a5.428 5.428 0 0 0 3.01-7.062L86.012 47.84a9.868 9.868 0 0 0-7.879-6.104ZM62.834 57.162l23.177-9.322M73.071 82.616l23.178-9.322",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.316 72.126c2.743-1.103 3.724-5.086 2.192-8.896-1.532-3.81-4.998-6.003-7.74-4.9-2.744 1.103-3.725 5.086-2.193 8.895 1.532 3.81 4.998 6.004 7.74 4.9ZM62.923 35.608h10.326M49.164 52.958a3.262 3.262 0 0 1-.597-2.767l3.477-14.204 1.232.522 1.246-2.944a1.265 1.265 0 0 0-.67-1.657l-6.574-2.783a1.265 1.265 0 0 0-1.657.672l-1.246 2.944 1.233.521-7.779 12.383a3.261 3.261 0 0 1-2.403 1.497 9.869 9.869 0 0 0-7.987 5.96L15.555 81.174a5.424 5.424 0 0 0 1.13 5.924c.5.508 1.095.912 1.752 1.19l13.009 5.508a5.429 5.429 0 0 0 7.114-2.881l11.885-28.073a9.87 9.87 0 0 0-1.28-9.884ZM27.439 53.102l23.005 9.74M16.743 78.367l23.005 9.739",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.523 72.691c1.601-3.781.692-7.78-2.03-8.933-2.723-1.153-6.228.978-7.829 4.76-1.6 3.78-.691 7.78 2.031 8.933 2.723 1.153 6.227-.978 7.828-4.76ZM41.174 40.502h9.764",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.623 15.763v4.849M47.214 17.664l2.635 4.07M62.548 17.664l-2.635 4.07M67.456 47.033l5.993-2.41M75.339 43.863l.326-.13M37.91 49.052l5.948 2.518M45.733 52.364l.324.137",
    stroke: "#C3985A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpFeatureIcon3);
export default __webpack_public_path__ + "static/media/mp-feature-icon-3.fd1f4a9918d1aa57720e9aa0efa03406.svg";
export { ForwardRef as ReactComponent };